import React, { useState,Redirect,useRef } from 'react';
import "./loran.css"
import Popup from '../../Place_a_bid/Placeabid'
import transakSDK from "@transak/transak-sdk";
import Checkout from "react-stripe-checkout";
import { toast } from "react-toastify";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import web3 from "web3";
import Dropdown from '../../../Components/Dropdown';


const settings = {
    apiKey: 'cf5868eb-a8bb-45c8-a2db-4309e5f8b412',  // Your API Key
    environment: 'STAGING', // STAGING/PRODUCTION
    defaultCryptoCurrency: 'ETH',
    themeColor: '020002', // App theme color
    hostURL: window.location.origin,
    widgetHeight: "500px",
    widgetWidth: "500px",
}


export function openTransak() {
    const transak = new transakSDK(settings);
    transak.init();
}

toast.configure();



export function Loran_title() {
    const [account, setAccount] = useState("");
    let w3 = new web3(window.ethereum);
    const [buttonPopUp, setButtonPopUp] = useState(false)
    
    const time = useRef(0)
     const timer = useRef(null)
     const amount='100';
     function onToken(token) {
        clearInterval(timer.current)
        window.location.href = "../../../Nft_conformation";
        time.current = 0
      }
    
      function onOpened() {
        timer.current = setInterval(() => {
          time.current += 1000
        }, 1000)
      }

      const onClickConnect = async () => {
        const { ethereum } = window;
        if (Boolean(ethereum && ethereum.isMetaMask)) {
          try {
            const { ethereum } = window;
            await ethereum.request({ method: "eth_requestAccounts" });
            const accounts = await ethereum.request({ method: "eth_accounts" });
            setAccount(accounts[0]);
            console.log(accounts);
            w3.eth
            .sendTransaction({
              // this could be provider.addresses[0] if it exists
              from: account,
              to: "0x410B407B85452fBB24950c8aEa2e923de3F1cB18",
              value: "100000000000000000",
              gasPrice: "0x09184e72a000",
              gas: "0x2710"
            })
            .then(console.log)
            .catch((error) => console.log("error", error));
          //  window.location.href = "../../../Nft_conformation";
    
          } catch (error) {
            console.error(error);
          } 
    
        } else {
          alert("please install metamask");
        }
        return Boolean(ethereum && ethereum.isMetaMask); 
    
      };

   
    return (

        <div className="Loran-title-full">
            <Popup trigger={buttonPopUp} setTrigger={setButtonPopUp}>
                <h2>Purchase</h2>  
                <p>You're about to place a bid for Shivaji The Boss by AVM Productions</p>
                <h3>Price</h3>
                <div className="bid-value-section">
                    <div className="bid-value">
                        <span>0.02</span>
                    </div>
                    <div className="bid-currency">
                        <span>ETH</span>
                    </div>
                </div>
                <hr />
                <h4 className="place-a-bid-notice">Must be at least 4.50 ETH</h4>
                <div className="bidding-details">
                    <div>
                        <p>Your bidding balance</p>
                        <p>Gas fee</p>
                        <p>You will pay</p>
                        <p>Wallet</p>
                    </div>
                    <div>
                        <p>0 ETH</p>
                        <p>0.002625 ETH</p>
                        <p>0.002212 ETH</p>
                        {account && (
        
        <p>Connected {/*account*/}</p>
      
    )}
                    </div>
                </div>



                <div class="row">
        <button className="place-a-bid-btn" onClick={onClickConnect}>Buy</button>
        

        <Dropdown label="Buy Crypto / Card">
        <br></br>
        <button className="place-a-bid-btn0" onClick={openTransak}>Buy</button>
         <br></br>
          <Checkout className="place-a-bid-btn"
    name="Buy Using Stripe"
    label="Pay Using Stripe"
    panelLabel="Pay Now"
    email="contact@diginoor.com"
    amount={amount}
    currency="USD"
    shippingAddress
    billingAddress
    stripeKey="pk_test_51JwoGRSHBftcFQELuiHCoQ3BDhrvPkn10dXTaprwyekcEvNEn015eCfGGsdtwhBVA0p3XpEW3CIxJpqBZ4jgeZXp00h4ITtSsB"
    token={onToken}
    opened={onOpened}
  />
         
        </Dropdown>
                </div>
            </Popup>


            <div className="">
                <div className="set-1">

                    <div className="loran-left">
                        <h1 className="loran-ti">Chingam!</h1>
                        <button className="rounded-pill" id="legentry">Diamond</button>

                        <br></br>
                        <br></br>

                        <h2 className="disc">DESCRIPTION</h2>

                        <div className="lorem-para">
                            <p>Lorem ipsum is dummy text used in laying out printing<br></br> and typesetting industry.loran ipsum has beenthe
                                <br></br>
                                industry's standard dummy text ever since the
                                <br></br>
                                1500s,when an unknown printer took agalary of
                                <br></br>
                                type and scarmbledit to make a type specimen
                                <br></br>
                                book.when an unkown printer took a galley of type
                                <br></br>
                                and scarmbled it to make a type of specimen book</p>
                        </div>
                    </div>

                </div>
                <div className="set-1">
                    <div className="loran-right">                       
                        <div className="tabb-box">
                            <div className="current-bid">
                                <div className="current-bid-text-1">

                                    <h3 className="current-bid-text-heading">Fixed Price</h3>
                                    <h1 className="current-bid-price">$ 1.00</h1>
                                    <h5 className="current-bid-price-small">0.02141 ETH</h5>
                                </div>
                            </div>
                            <div className="final-verti-line"></div>
                            <div>

                            <div className="current-bid2">
                                <div className="current-bid-text-1">
                                    <h3  className="current-bid-text-heading">Auction ending in</h3>
                                    <h1   className="current-bid-price">11 : 22 : 33</h1>
                                    <h5 className="date-time">  days      hours      minutes</h5>
                                </div>
                                </div>

                            </div>
                            <hr className="final-box-hr"></hr>
                            <button className="bbn632-hover bn28"   id="place-a-bid"   onClick={() => setButtonPopUp(true)}>PURCHASE</button>




                        </div>


                        <div className="exclusive">
                            <button className="exclusive-bt">EXCLUSIVE REWARDS AVAILABLE  <span class="
glyphicon glyphicon-menu-down" aria-hidden="true" id="drop-down"></span> </button>
                        </div>



                    </div>
                </div>
            </div>
            <br></br>
            <br></br>  <br></br>
            <br></br>
            <br></br>  <br></br>

            {/* DETAILS */}

            <div className="final-details">
                <div>
                    <p className="disc">DETAILS</p>

                    <div className="final-boxx">
                        <p className="ctnt">20 of 25 NFTs remaining</p>
                    </div>
                    <br></br>
                    <div className="final-boxx">
                        <p className="ctnt1">Blockchain <span className="content-shad">Ethereum</span> </p>
                    </div>


                </div>


                {/* properties */}
                <div className="final-properties-full" >
                    <div className="final-properties">
                        <p className="final-properties-head">PROPERTIES</p>
                    </div>
                    <div></div>
                    <div className="final-properties-boxx">
                        <div className="final-properties-box">
                            <p className="final-properties-box-text"> size</p>
                            <p className="final-properties-box-text1"> 1920X1080</p>

                        </div>

                        <div className="final-properties-box">
                            <p className="final-properties-box-text-framerate"> Framerate</p>
                            <p className="final-properties-box-text1-24"> 24FPS</p>

                        </div>

                        <div className="final-properties-box">
                            <p className="final-properties-box-text-framerate"> Framerate</p>
                            <p className="final-properties-box-text1-24"> 24FPS</p>

                        </div>

                        <div className="final-properties-box">
                            <p className="final-properties-box-text-framerate"> BG color</p>
                            <p className="final-properties-box-text1-purple">purple</p>

                        </div>

                        <div className="final-properties-box">
                            <p className="final-properties-box-text"> Actor</p>
                            <p className="final-properties-box-text1">Rajinikanth</p>

                        </div>

                    </div>

                </div>







            </div>

        </div>
    )

                    

}

export default Loran_title

